module.exports = __webpack_public_path__ + "static/cake_mousse_02-4562593c83828cf49bb0812aefdc07f5.jpg";